import Layout from '@/layout';
var artResourceRouter = {
  path: '/artResource',
  component: Layout,
  redirect: '/artResource/list',
  name: 'ArtResource',
  alwaysShow: true,
  meta: {
    title: '艺术资源',
    icon: 'collection'
  },
  children: [{
    path: 'creator',
    component: function component() {
      return import('@/views/artResource/creator');
    },
    name: 'ArtResourceCreator',
    meta: {
      title: '创作者申请'
    }
  }, {
    path: 'category',
    component: function component() {
      return import('@/views/artResource/category');
    },
    name: 'ArtResourceCategory',
    meta: {
      title: '资源分类'
    }
  }, {
    path: 'list',
    component: function component() {
      return import('@/views/artResource/list');
    },
    name: 'ArtResourceList',
    meta: {
      title: '资源列表'
    }
  }, {
    path: 'order',
    component: function component() {
      return import('@/views/artResource/order');
    },
    name: 'ArtResourceOrder',
    meta: {
      title: '全部订单'
    }
  }, {
    path: 'physicalOrder',
    component: function component() {
      return import('@/views/artResource/physicalOrder');
    },
    name: 'ArtResourcePhysicalOrder',
    meta: {
      title: '实物订单'
    }
  }]
};
export default artResourceRouter;